import { Stack, Typography } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import UserContext from "../../../context/UserContext";
import ClientEmailAccounts from "./ClientEmailAccounts";
import type { ClientProfile } from "./clientProfilesTypes";
import OrganizationEmailAccounts from "./OrganizationEmailAccounts";

interface Props {
  selectedClient: ClientProfile;
  clientsByCode: Map<string, ClientProfile>;
  onSelectClient: (clientCode: string) => void;
}

const ClientProfileEmailAccountsSection = ({ selectedClient, clientsByCode, onSelectClient }: Props) => {
  const { permissions } = useDefinedContext(UserContext);

  if (!permissions.includes("ViewClientEmailAccounts")) {
    return null;
  }

  return (
    <Stack spacing={1}>
      <Typography variant="h6">Email Accounts</Typography>
      {selectedClient.type === "FundAdmin" ? (
        <OrganizationEmailAccounts
          key={selectedClient.clientCode}
          organizationCode={selectedClient.clientCode}
          clientsByCode={clientsByCode}
          onSelectClient={onSelectClient}
        />
      ) : (
        <ClientEmailAccounts key={selectedClient.clientCode} clientCode={selectedClient.clientCode} />
      )}
    </Stack>
  );
};

export default ClientProfileEmailAccountsSection;
